import { render, staticRenderFns } from "./legalKnowledge.vue?vue&type=template&id=561acaba&scoped=true&"
import script from "./legalKnowledge.vue?vue&type=script&lang=js&"
export * from "./legalKnowledge.vue?vue&type=script&lang=js&"
import style0 from "./legalKnowledge.vue?vue&type=style&index=0&id=561acaba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561acaba",
  null
  
)

export default component.exports